export const TAGS_UPLOAD_STEP_TITLE = 'Tag Upload';
export const TAGS_UPLOAD_DROPZONE_TITLE = 'Upload Tag Sheet';
export const TAGS_UPLOAD_UPLOAD_MESSAGE = 'Uploading tag sheet file';
export const TAGS_UPLOAD_DROP_TEXT = 'Drop Excel files here or import from:';
export const TAGS_UPLOAD_FILE_LABEL = 'File to upload:';
export const TAGS_UPLOAD_INFO_TEXT = 'Please upload the DCM tag sheet before proceeding.';
